export const SOCIAL_MEDIA_PLATFORMS = {
  LINKEDIN: {
    name: 'linkedin',
    icon: 'mdi-linkedin',
    patterns: ['linkedin.com'],
  },
  TWITTER: {
    name: 'twitter',
    icon: 'mdi-twitter',
    patterns: ['twitter.com', 'x.com'],
  },
  FACEBOOK: {
    name: 'facebook',
    icon: 'mdi-facebook',
    patterns: ['facebook.com'],
  },
  INSTAGRAM: {
    name: 'instagram',
    icon: 'mdi-instagram',
    patterns: ['instagram.com'],
  },
  YOUTUBE: {
    name: 'youtube',
    icon: 'mdi-youtube',
    patterns: ['youtube.com', 'youtu.be'],
  },
  TIKTOK: {
    name: 'tiktok',
    icon: 'mdi-music-note', // TikTok specific icon
    patterns: ['tiktok.com'],
  },
  PINTEREST: {
    name: 'pinterest',
    icon: 'mdi-pinterest',
    patterns: ['pinterest.com'],
  },
  SNAPCHAT: {
    name: 'snapchat',
    icon: 'mdi-snapchat',
    patterns: ['snapchat.com'],
  },
  REDDIT: {
    name: 'reddit',
    icon: 'mdi-reddit',
    patterns: ['reddit.com'],
  },
  WHATSAPP: {
    name: 'whatsapp',
    icon: 'mdi-whatsapp',
    patterns: ['whatsapp.com'],
  },
  TELEGRAM: {
    name: 'telegram',
    icon: 'mdi-telegram',
    patterns: ['telegram.org', 't.me'],
  },
  GITHUB: {
    name: 'github',
    icon: 'mdi-github',
    patterns: ['github.com'],
  },
  DISCORD: {
    name: 'discord',
    icon: 'mdi-discord',
    patterns: ['discord.com', 'discord.gg'],
  },
  TWITCH: {
    name: 'twitch',
    icon: 'mdi-twitch',
    patterns: ['twitch.tv'],
  },
  VIMEO: {
    name: 'vimeo',
    icon: 'mdi-vimeo',
    patterns: ['vimeo.com'],
  },
  SPOTIFY: {
    name: 'spotify',
    icon: 'mdi-spotify',
    patterns: ['spotify.com'],
  },
  SOUNDCLOUD: {
    name: 'soundcloud',
    icon: 'mdi-soundcloud',
    patterns: ['soundcloud.com'],
  },
  MEDIUM: {
    name: 'medium',
    icon: 'mdi-medium',
    patterns: ['medium.com'],
  },
  BEHANCE: {
    name: 'behance',
    icon: 'mdi-behance',
    patterns: ['behance.net'],
  },
  DRIBBBLE: {
    name: 'dribbble',
    icon: 'mdi-dribbble',
    patterns: ['dribbble.com'],
  },
  SLACK: {
    name: 'slack',
    icon: 'mdi-slack',
    patterns: ['slack.com'],
  },
  SKYPE: {
    name: 'skype',
    icon: 'mdi-skype',
    patterns: ['skype.com'],
  },
  WECHAT: {
    name: 'wechat',
    icon: 'mdi-wechat',
    patterns: ['wechat.com'],
  },
  VK: {
    name: 'vk',
    icon: 'mdi-vk',
    patterns: ['vk.com'],
  },
  TUMBLR: {
    name: 'tumblr',
    icon: 'mdi-tumblr',
    patterns: ['tumblr.com'],
  },
  FLICKR: {
    name: 'flickr',
    icon: 'mdi-flickr',
    patterns: ['flickr.com'],
  },
  MEETUP: {
    name: 'meetup',
    icon: 'mdi-account-group', // Using a generic group icon for Meetup
    patterns: ['meetup.com'],
  },
  QUORA: {
    name: 'quora',
    icon: 'mdi-help-circle', // Using a question mark icon for Quora
    patterns: ['quora.com'],
  },
  STRAVA: {
    name: 'strava',
    icon: 'mdi-run', // Using a running icon for Strava
    patterns: ['strava.com'],
  },
  PATREON: {
    name: 'patreon',
    icon: 'mdi-currency-usd-circle', // Using a money icon for Patreon
    patterns: ['patreon.com'],
  },
  DEVIANTART: {
    name: 'deviantart',
    icon: 'mdi-deviantart',
    patterns: ['deviantart.com'],
  },
  STEAM: {
    name: 'steam',
    icon: 'mdi-steam',
    patterns: ['steampowered.com', 'steamcommunity.com'],
  },
  BITBUCKET: {
    name: 'bitbucket',
    icon: 'mdi-bitbucket',
    patterns: ['bitbucket.org'],
  },
  GITLAB: {
    name: 'gitlab',
    icon: 'mdi-gitlab',
    patterns: ['gitlab.com'],
  },
  STACKOVERFLOW: {
    name: 'stackoverflow',
    icon: 'mdi-stack-overflow',
    patterns: ['stackoverflow.com'],
  },
  CODEPEN: {
    name: 'codepen',
    icon: 'mdi-codepen',
    patterns: ['codepen.io'],
  },
  MASTODON: {
    name: 'mastodon',
    icon: 'mdi-mastodon',
    patterns: ['.social', 'mastodon.social'],
  },
  THREADS: {
    name: 'threads',
    icon: 'mdi-at', // Using @ symbol for Threads
    patterns: ['threads.net'],
  },
  BLUESKY: {
    name: 'bluesky',
    icon: 'mdi-cloud', // Using cloud icon for Bluesky
    patterns: ['bsky.app'],
  },
  SUBSTACK: {
    name: 'substack',
    icon: 'mdi-newspaper', // Using newspaper icon for Substack
    patterns: ['substack.com'],
  },
};

export const MAX_SOCIAL_MEDIA_PROFILES = 5;
// MAX_KEYWORDS is now driven by license permissions (permissions.keywords from GET /licensing)
// Default fallback used only when license data is not available
export const MAX_KEYWORDS_DEFAULT = 10;

export const isValidUrl = url => {
  try {
    const urlObject = new URL(url);
    return urlObject.protocol === 'http:' || urlObject.protocol === 'https:';
  } catch (e) {
    return false;
  }
};

export const getSocialMediaPlatform = url => {
  const lowerUrl = url.toLowerCase();
  return Object.values(SOCIAL_MEDIA_PLATFORMS).find(platform => platform.patterns.some(pattern => lowerUrl.includes(pattern))) || null;
};

export const validateSocialMediaUrl = url => {
  if (!url || typeof url !== 'string') {
    return {
      isValid: false,
      message: 'Please enter a URL',
    };
  }

  if (!isValidUrl(url)) {
    return {
      isValid: false,
      message: 'Please enter a valid URL (starting with http:// or https://)',
    };
  }

  const platform = getSocialMediaPlatform(url);
  if (!platform) {
    return {
      isValid: false,
      message: 'URL must be from a supported social media platform',
    };
  }

  return {
    isValid: true,
    message: '',
    platform,
  };
};

export const validateSocialMediaLimit = currentProfiles => {
  if (!Array.isArray(currentProfiles)) {
    return {
      isValid: false,
      message: 'Invalid profiles data',
    };
  }

  const uniqueProfiles = new Set(currentProfiles.map(profile => profile.platform?.name)).size;
  const remainingSlots = MAX_SOCIAL_MEDIA_PROFILES - uniqueProfiles;

  return {
    isValid: uniqueProfiles <= MAX_SOCIAL_MEDIA_PROFILES,
    message: remainingSlots < 0
      ? `Maximum ${MAX_SOCIAL_MEDIA_PROFILES} social media profiles allowed. Please remove an existing profile before adding a new one.`
      : `You can add up to 5 social media ${remainingSlots === 1 ? 'profile' : 'profiles'}.`,
    remainingSlots,
  };
};

export const validateKeywordsLimit = (currentKeywords, maxKeywords = MAX_KEYWORDS_DEFAULT) => {
  if (!Array.isArray(currentKeywords)) {
    return {
      isValid: false,
      message: 'Invalid keywords data',
    };
  }

  const remainingSlots = maxKeywords - currentKeywords.length;

  return {
    isValid: currentKeywords.length <= maxKeywords,
    message: remainingSlots < 0
      ? `Maximum ${maxKeywords} keywords allowed. Please remove an existing keyword before adding a new one.`
      : `You can add ${remainingSlots} more ${remainingSlots === 1 ? 'keyword' : 'keywords'}.`,
    remainingSlots,
  };
};

export const isSocialMediaLimitReached = currentProfiles => {
  if (!Array.isArray(currentProfiles)) return true;
  return currentProfiles.length >= MAX_SOCIAL_MEDIA_PROFILES;
};

export const isKeywordsLimitReached = (currentKeywords, maxKeywords = MAX_KEYWORDS_DEFAULT) => {
  if (!Array.isArray(currentKeywords)) return true;
  return currentKeywords.length >= maxKeywords;
};
